import { render, staticRenderFns } from "./participant-day-zero-details.vue?vue&type=template&id=5bb4cb5c&scoped=true&"
import script from "./participant-day-zero-details.vue?vue&type=script&lang=js&"
export * from "./participant-day-zero-details.vue?vue&type=script&lang=js&"
import style0 from "./participant-day-zero-details.vue?vue&type=style&index=0&id=5bb4cb5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4cb5c",
  null
  
)

component.options.__file = "participant-day-zero-details.vue"
export default component.exports